import styles from './BackButton.module.scss';
import { useHistory } from 'react-router';
import GlobalContext from '../../contexts/GlobalContext';
import { FC, useContext } from 'react';
import { Button, Icon } from '@mui/material';

type TBackButtonProps = {
    onGoBack?: () => void;
};

const BackButton: FC<TBackButtonProps> = (props) => {
    const { language } = useContext(GlobalContext);
    const { onGoBack } = props;
    const history = useHistory();

    const handleGoBack = () => {
        onGoBack ? onGoBack() : history.goBack();
    };

    return (
        <Button variant="text" onClick={handleGoBack} startIcon={<Icon>arrow_back_ios</Icon>}>
            {language.common.back}
        </Button>
    );
};

export default BackButton;
